import { cn } from '@/lib/utils';
import type { CMSInlineTextImage } from '../schemas';
import { HTMLContent } from '@/components/ui/html-content';

interface CMSInlineTextImageProps {
  inlineTextImageData: CMSInlineTextImage;
  className?: string;
}

const CMSInlineTextImage = ({
  inlineTextImageData,
  className,
}: CMSInlineTextImageProps) => {
  const imagePosition = inlineTextImageData.image_position.key;
  const richText = inlineTextImageData.rich_text;

  return (
    <div
      className={cn('flex flex-row items-center gap-1 mb-8', {}, className)}
      data-component="CMSInlineTextImage"
    >
      <div
        className={cn('richText font-nunito500 [&_strong]:font-nunito700', {
          'order-2': imagePosition === 'start',
          'order-1': imagePosition === 'end',
        })}
      >
        <HTMLContent content={richText} />
      </div>

      <div
        className={cn('!mt-0 flex flex-row gap-1', {
          'order-1': imagePosition === 'start',
          'order-2': imagePosition === 'end',
        })}
      >
        {inlineTextImageData.image?.map((value, index) => (
          <img
            key={index}
            className="w-auto"
            src={value.url}
            alt={value.alt ?? ''}
            loading="lazy"
          />
        ))}
      </div>
    </div>
  );
};

export { CMSInlineTextImage };
